import BaseBehavior from '../../../framework/base/base';

export default class TableHighlight extends BaseBehavior {
	constructor(element) {
		super(element);

		const panelSel = element.closest('.v2-panel');
		const panelHeaderSel = panelSel && panelSel.querySelector('.v2-panel__header');
		const panelBgColor = panelHeaderSel && window.getComputedStyle(panelHeaderSel).backgroundColor;
		const bodyBgColor = window.getComputedStyle(document.body).backgroundColor;
		this.backgroundColor = panelBgColor || bodyBgColor || 'rgb(255, 255, 255)';
		this.element.querySelector('table').style.backgroundColor = this.backgroundColor;
		this.unhighlightedTds = element.querySelectorAll(
			'.v2-dummy-row td:not(.v2-table__highlight--col)'
		);
		Array.from(this.unhighlightedTds).forEach(item => {
			item.style.backgroundColor = this.backgroundColor;
		});
		element.style.backgroundColor = this.backgroundColor;
	}
}
